import { CloseTemplateViewConfig } from "@common/types/closeTemplateViewConfig";
import { ComponentType } from "react";
import { TaskType } from "@common/types/task";
import type { CloseTemplateBasis } from "@common/types/closeTemplateBasis";
import {
    CloseTemplateTaskBalanceSheetPreview,
    CloseTemplateTaskProfitLossPreview,
} from "../CloseTemplateTaskReportPreview";
import { CloseTemplateTaskBillsPreview } from "../CloseTemplateTaskBillsPreview";
import { CloseTemplateTaskCounterpartiesPreview } from "../CloseTemplateTaskCounterpartiesPreview";
import { CloseTemplateTaskFinancialDocumentsPreview } from "../CloseTemplateTaskFinancialDocumentsPreview";
import { CloseTemplateTaskForm1099Preview } from "../CloseTemplateTaskForm1099Preview";
import { CloseTemplateTaskInvoicesPreview } from "../CloseTemplateTaskInvoicesPreview";
import { CloseTemplateTaskTransactionsPreview } from "../CloseTemplateTaskTransactionsPreview";

export interface TemplateTaskPreviewProps {
    taskType: TaskType;
    viewConfig: CloseTemplateViewConfig | null;
    onViewConfigChange: (viewConfig: CloseTemplateViewConfig) => void;
    basis?: CloseTemplateBasis | null;
}

export const TEMPLATE_PREVIEW_BY_TASK_TYPE: Partial<
    Record<TaskType, ComponentType<TemplateTaskPreviewProps>>
> = {
    [TaskType.TRANSACTIONS]: CloseTemplateTaskTransactionsPreview,
    [TaskType.TRANSACTION_REVIEW]: CloseTemplateTaskTransactionsPreview,
    [TaskType.PROFIT_LOSS]: CloseTemplateTaskProfitLossPreview,
    [TaskType.BALANCE_SHEET]: CloseTemplateTaskBalanceSheetPreview,
    [TaskType.FORM_1099]: CloseTemplateTaskForm1099Preview,
    [TaskType.COUNTERPARTIES]: CloseTemplateTaskCounterpartiesPreview,
    [TaskType.BILLS]: CloseTemplateTaskBillsPreview,
    [TaskType.INVOICES]: CloseTemplateTaskInvoicesPreview,
    [TaskType.FINANCIAL_DOCUMENTS]: CloseTemplateTaskFinancialDocumentsPreview,
};
